import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import logo from "./assets/logo.png";
import "./Navbar.css";

function Navbar() {
  const [active, setActive] = useState("nav__menu");
  const [icon, setIcon] = useState("nav__toggler");
  const navigate = useNavigate();
  const location = useLocation();
  const navRef = useRef(null);

  useEffect(() => {
    // Close the navigation menu when navigating to a different page
    setActive("nav__menu");
    setIcon("nav__toggler");
  }, [location.pathname]);

  useEffect(() => {
    function handleOutsideClick(event) {
      if (navRef.current && !navRef.current.contains(event.target)) {
        setActive("nav__menu");
        setIcon("nav__toggler");
      }
    }

    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  const isHomeScreen = location.pathname === "/";

  const navToggle = () => {
    if (isHomeScreen) {
      setActive((prevClass) =>
        prevClass.includes("nav__active")
          ? "nav__menu"
          : "nav__menu nav__active"
      );
    }
  };

  return (
    <nav className="nav" ref={navRef}>
      <a href="#" className="nav__brand">
        <img
          onClick={() => navigate("/")}
          className="nav-logo"
          src={logo}
          alt="logo"
          style={{ height: "62px" }}
        />
      </a>
      <ul className={active}>
        {/* Home */}
        {/* Home */}
        <li onClick={() => navigate("/")}>
          <a className="homestyle">Home</a>
        </li>

        {/* ABOUT */}
        <li className="nav__item">
          <a className="nav__link">
            <a className="dropdown">
              <button className="dropbtn">ABOUT</button>
              <div className="dropdown-content">
                <a
                  href="https://kippra.or.ke/"
                  target="_blank"
                  rel="noreferrer"
                >
                  Kippra
                </a>
                <button
                  onClick={() => navigate("/conference")}
                  className={
                    location.pathname === "/conference"
                      ? "items active"
                      : "items"
                  }
                >
                  Kippra Conference
                </button>
              </div>
            </a>
          </a>
        </li>

        {/* OUR SPEAKERS */}
        <li className="homestyle">
          <a className="nav__link">OUR SPEAKERS</a>
        </li>

        {/* GALLERY */}
        <li className="nav__item">
          <a className="nav__link">
            <a className="dropdown">
              <button className="dropbtn">GALLERY</button>
              <div className="dropdown-content">
                <a href="/">PICTURES</a>
                <button
                  onClick={() => navigate("/vid")}
                  className={
                    location.pathname === "/vid" ? "items active" : "items"
                  }
                >
                  VIDEOS
                </button>
              </div>
            </a>
          </a>
        </li>

        {/* Register */}
        <button onClick={() => navigate("/profile")} className="regbutton">
          Register
        </button>
      </ul>
      <div onClick={navToggle} className={isHomeScreen ? icon : "nav__toggler"}>
        <div className="line1"></div>
        <div className="line2"></div>
        <div className="line3"></div>
      </div>
    </nav>
  );
}

export default Navbar;
